// src/Components/Header.js

import React, { useState, useEffect } from "react";
import { useAuth } from '../AuthContext'; // Import useAuth from AuthContext
import { Container, Navbar, Nav } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../Config';
import { isRsaSaleContext } from '../utils/rsaSale';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../Pages/Company/Company.css';

const Header = () => {
    const { logout } = useAuth(); // Access logout function from AuthContext
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null); // Store user data
    const [isRsaSale, setIsRsaSale] = useState(false);


    // Load user data from sessionStorage on component mount
    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (user) {
            setUserData(user);
            setIsRsaSale(isRsaSaleContext(user));
        }
    }, []);

    // Handle logout functionality
    const handleLogout = () => {
        handleLogOutApi()
    };

    const handleLogOutApi = async () => {
        const userId = userData.userId;
        try {
            const response = await axios.post(`${BASE_URL}Retail_Logout`, {
                userId

            }, {
                headers: {
                    'Accept': '*/*',
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.responseCode === "0000") {
                const userData = response.data;
                logout(); // Call logout function from context to reset global auth state
                sessionStorage.removeItem("user");
                // setUserData(null); // Optionally clear user data from state
                console.log('Logout successful'); // Debugging output


                navigate('/');

                // Check the userRole and navigate accordingly

            } else {

            }
        } catch (error) {
            console.error('Logout error:', error);
        }
    };



    return (
        <Navbar
            expand="lg"
            sticky="top"
            className={isRsaSale ? 'co-navbar py-2 mb-0' : 'bg-body-tertiary'}
            style={isRsaSale ? undefined : { borderRadius: '25px' }}
        >
            <Container fluid={isRsaSale ? 'xl' : undefined}>
                <Navbar.Brand href={`/Sales/Sales`} className="d-flex align-items-center gap-2">
                    {isRsaSale ? (
                        <img
                            src="/RSA_Pakistan_Logo.png"
                            className="co-rsa-logo"
                            alt="RSA Pakistan"
                        />
                    ) : (
                        <img src="../Webdoc_Logo.webp" style={{ width: "90px" }} alt="logo" />
                    )}
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-lg-center gap-1">
                        {userData ? (
                            <>
                                {userData.userId === "a06b7831-d8d8-4804-9551-60e353461acc" && (
                                    <Nav.Link href="/Sales/Sales_Testing">Sales_Testing</Nav.Link>
                                )}
                                <span className="badge text-bg-light border text-dark px-3 py-2">
                                    <i className="bi bi-person-circle me-1" />
                                    {userData?.name}
                                </span>
                                <Nav.Link onClick={handleLogout}>LogOut</Nav.Link>
                            </>
                        ) : (
                            <Nav.Link href="/">Login</Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );


};

export default Header;

